import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/pro-regular-svg-icons";

export default function PleaseWaitAlert() {
  return (
    <div className="alert alert-info mt-2">
      <FontAwesomeIcon className="mr-1" icon={faSpinner} spin />
      {I18n.t("js.please_wait")}
    </div>
  );
}
